import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetTagsInput, Result, ResultList, TagInput, TagResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(private httpClient: HttpClient) { }

  public addTag(tagInput: TagInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Tag/AddTag', tagInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editTag(id: number, tagInput: TagInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Tag/EditTag?id=' + id, tagInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteTag(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Tag/DeleteTag?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getTags(getTagsInput: GetTagsInput): Promise<ResultList<TagResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Tag/GetTags', getTagsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<TagResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<TagResult>(), result.error));
  }
}